import moment from 'moment'

export const colors = ['#80CBC4', '#90CAF9', '#FFE089', '#FF9A9A', '#DDE6E8', '#ffcc80', '#b39ddb', '#c5e1a5', '9FA8DA']

export const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
    'Content-Type': 'application/json'
}

export const breakPoints = {
    'all': 0,
    'xs': 400,
    'sm': 640,
    'md': 768,
    'lg': 1024,
    'xl': 1280,
    'xxl': 1400
}

export const getHeadersWithAccessToken = function () {
    let newHeaders = JSON.parse(JSON.stringify(headers))
    newHeaders['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
    return newHeaders
}

export const getHeadersWithRefreshToken = function () {
    let newHeaders = JSON.parse(JSON.stringify(headers))
    newHeaders['Authorization'] = 'Bearer ' + localStorage.getItem('refresh_token')
    return newHeaders
}

export const getNumberOfWeek = function (date) {
    return moment(date).isoWeek()
}

export const getWeekNumber = function (d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
    return [d.getUTCFullYear(), weekNo]
}

export const serialize = function (obj) {
    var str = []
    for (var p in obj) {
        if (Array.isArray(obj[p])) {
            for (let i = 0; i < obj[p].length; i++) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p][i]))
            }
        } else if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
        }
    }
    return str.join('&')
}

export const getDateOfISOWeek = function (w, y) {
    var simple = new Date(y, 0, 1 + (w - 1) * 7)
    var dow = simple.getDay()
    var ISOweekStart = simple
    if (dow <= 4) { ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1) } else { ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay()) }
    return ISOweekStart
}

export const calculateSum = (obj, field) => obj
    .map(items => items.attributes[field])
    .reduce((prev, curr) => prev + curr, 0)

export const getTableHeaders = function (cols) {
    let headers = []
    for (let col of cols) {
        let format = col.replace('_', ' ')
        format = format.replace('_', ' ')
        format = format.charAt(0).toUpperCase() + format.slice(1)
        headers.push({ 'prop': col, 'key': col, 'label': format })
    }
    return headers
}

export const formatString = function (value) {
    try {
        let variable = value.replace('_', ' ')
        variable = variable.replace('_', ' ')
        return variable.charAt(0).toUpperCase() + variable.slice(1)
    } catch {
        return value
    }
}

export const arrayToCSV = function (objArray, seperator = ';') {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(seperator)}` + '\r\n'

    return array.reduce((str, next) => {
        str += `${Object.values(next).map(value => `"${value}"`).join(seperator)}` + '\r\n'
        return str
    }, str)
}
